import React, { Component, Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'react-router-redux'
import { connect } from 'react-redux'
import AppHeader from './components/Header'
import { Layout } from 'antd'
import Page404 from './containers/StaticPages/404'
import config from './config'

const { ROUTER_CONFIG } = config

const { Content } = Layout

class PublicRoutes extends Component {
  render () {
    const { overlay, history, onLocaleChange, locale } = this.props
    return (
      <ConnectedRouter history={history}>
        <Layout>
          {overlay}
          <Content >
            <Suspense fallback={<div />}>
              <Switch>
                {
                  locale === 'vn'
                    ? (ROUTER_CONFIG.slice(0, 1).map(({ exact, path, component: Component }) => (
                      <Route exact={exact} key={path} path={path}
                        render={(routerProps) =>
                        <>
                          <AppHeader onLocaleChange={onLocaleChange} locale={locale} />
                          {Component && <Component {...routerProps} />}
                      </>
                        }
                      />
                    )))
                    : (
                      ROUTER_CONFIG.map(({ exact, path, component: Component, showHeader = true }) => (
                        <Route
                          exact={exact} key={path} path={path}
                          render={(routerProps) =>
                          <>
                            {showHeader ? <AppHeader onLocaleChange={onLocaleChange} locale={locale} /> : null}
                            {Component && <Component {...routerProps} />}
                          </>
                          }
                        />
                      ))
                    )
                }
                <Route component={Page404} />
              </Switch>
            </Suspense>
          </Content>
        </Layout>
      </ConnectedRouter>
    )
  }
}

export default connect(state => ({
  overlay: state.App.overlay,
  router: state.router,
  LanguageSwitcher: state.LanguageSwitcher.language
}), {})(PublicRoutes)
